import { motion } from "framer-motion";
import {
  BookOpen, GraduationCap, HeartPulse, Scale, Banknote, ShieldCheck,
  ShoppingBag, Factory, Landmark, Building2, Newspaper, Cpu, Users2,
} from "lucide-react";

const industries = [
  { name: "Publishing", icon: BookOpen },
  { name: "Education", icon: GraduationCap },
  { name: "Healthcare", icon: HeartPulse },
  { name: "Legal", icon: Scale },
  { name: "Banking", icon: Banknote },
  { name: "Insurance", icon: ShieldCheck },
  { name: "Retail", icon: ShoppingBag },
  { name: "Manufacturing", icon: Factory },
  { name: "Museums", icon: Landmark },
  { name: "Government", icon: Building2 },
  { name: "Media", icon: Newspaper },
  { name: "Technology", icon: Cpu },
  { name: "Professional Associations", icon: Users2 },
];

const accents = ["#1F5EFF", "#6D28D9", "#00B8A9", "#0B1F3A"];

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="relative py-24 sm:py-32 bg-[#F8FAFC]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-12">
          <div className="overline">Industries We Serve</div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3A] tracking-tighter leading-[1.08]">
            Solutions built for every content ecosystem.
          </h2>
          <p className="mt-4 text-[#475569] text-base sm:text-lg">
            Whether you&rsquo;re publishing books, preserving cultural heritage, delivering educational content, or
            managing enterprise knowledge, Libros Consulting provides the expertise and technology to move your
            content forward.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {industries.map((ind, i) => {
            const Icon = ind.icon;
            const color = accents[i % accents.length];
            return (
              <motion.div
                key={ind.name}
                data-testid={`industry-card-${i}`}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.45, delay: (i % 5) * 0.05 }}
                className="lift-card group rounded-2xl bg-white border border-[#0B1F3A]/10 p-5 flex flex-col gap-4"
              >
                <div
                  className="inline-flex h-11 w-11 items-center justify-center rounded-xl transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3"
                  style={{ backgroundColor: `${color}14`, color }}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-display font-semibold text-[15px] text-[#0B1F3A] leading-snug">
                  {ind.name}
                </h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
